import React from 'react';
import { useTranslation } from 'react-i18next';
import MaintenanceConfig from '../utils/MaintenanceConfig';
import '../css/MaintenanceBanner.css';

const MaintenanceBanner = () => {
  const { t } = useTranslation('common');

  // Check if current time is within maintenance window
  const shouldShowBanner = MaintenanceConfig.shouldShowMaintenanceBanner();

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <div className="maintenance-banner">
      <div className="maintenance-banner-content">
        <div className="maintenance-banner-icon">
          ⚠️
        </div>
        <div className="maintenance-banner-text">
          <strong>Maintenance Notice:</strong> {t('maintenance.bannerMessage')}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
